import React from 'react';
import { ItemTraverser } from '../../containers/commerce';
import { Container, Row, Col } from '../../components/grid';
import {
  Heading1, Paragraph, LinkStyled, Heading2, List, Span,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="Fadoelsbar">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading1>Bar til fadølsanlæg</Heading1>
          <Paragraph>
            En fadølsbar giver et kraftigt løft til feststemningen. Her på siden finder du flere forskellige slags fadølsbarer, der klarer opgaven. Vælg mellem en klapbar, stilladsbar eller en hel udskænkningsvogn og skån dine egne borde mod øl og rander fra glas. Hos Skafte udlejer vi den helt rette fadølsbar til både erhverv og privat, så du bliver klar til din næste fest, event eller arrangement.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelsbar" display={ProductView1} triple />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Paragraph fontSize="12px" marginBottom="0px">
            En ny bar kan købes hos <LinkStyled external to="http://www.imagecreator.dk">Image Creator</LinkStyled>,
            tlf: 96 84 28 00 Pris ca. kr. 6000,- + moms.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Fadølsbar til din næste fest eller event</Heading2>
          <Paragraph>
            Man skal ikke græde over spildt øl - i hvert fald ikke når det er spildt på en fadølsbar og ikke dit eget bord. Hos Skafte kan du leje en fadølsbar til din næste fest, arrangement eller event, så du skåner dine egne borde og tilmed får den helt rette højde til dit <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled>.
          </Paragraph>
          <Paragraph>
            Her på siden kan du se hele vores udvalg af fadølsbarer, som vi lejer ud og som er den perfekte tilføjelse, når der skal være fest.
            Vælg mellem følgende:
          </Paragraph>
          <List>
            <li>Klapbar</li>
            <li>Stilladsbar</li>
            <li>Udskænkningsvogn</li>
          </List>
          <Paragraph>
            De har alle forskellig størrelse og derfor naturligvis også forskellige formål og styrker. Det er derfor vigtigt at vælge den rette, så du får den allerbedste brug ud af den og får en god fest.
          </Paragraph>
          <Paragraph>
            <Span underline block>Klapbar</Span>
            En klapbar kan med fordel vælges til mindre fester eller arrangementer eller som supplement til en af de andre typer fadølsbarer.
            Den fungerer i princippet som en ekstra bardisk. Denne type fadølsbar har en god arbejdshøjde, så den passer godt i højden, når du stiller en fadølshane ovenpå.
            Nedenunder baren er der plads til at stille både anlæg og fustager, så disse skjules og dermed ikke står fremme.
            Der er plads til en eller to fadølshaner på denne fadølsbar.
          </Paragraph>
          <Paragraph>
            <Span underline block>Stilladsbar</Span>
            Denne type fadølsbar egner sig bedst til større arrangementer, der kan holdes udendørs, i telte eller i større lokaler/lagerhaller. Gulvet må ikke være sart, da fadølsbaren er bygget af metalrør, der eventuelt kan efterlade ridser.
            Grundet barens opbygning, kan du med fordel anvende denne til festivaler eller lignende større arrangementer, som fx udendørs sommerfester.
            Nedenunder baren kan der skjules både anlæg og fustager.
            Der er plads til tre fadølshaner på denne fadølsbar.
          </Paragraph>
          <Paragraph>
            <Span underline block>Udskænkningsvogn</Span>
            Dette er den største version af en fadølsbar, som der kan lejes. Her er tale om en vogn og der kræves derfor god plads. Skal placeres udendørs og har halvtag, der kan slås ud, så folk kan stå i læ.
            Vognen har hele to kraftige fadølskølere med to haner hver. Der er altså fire fadølshaner på denne fadølsbar.
            Hvis du ønsker at bruge alle fire haner samtidig, skal denne fadølsbar/vogn tilsluttes 400 volt. Ved brug af to af hanerne, skal fadølsbaren tilsluttes 230 volt.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Fadølsbar til erhverv
          </Heading2>
          <Paragraph>
            Hvis du ønsker at leje en fadølsbar i erhvervsregi, kan du vælge at se priserne uden moms.
            Vi hjælper gerne med at vælge den rette størrelse bar til den næste fest eller arrangement, hvis du er i tvivl om hvilken fadølsbar der skal vælges. Kontakt os gerne - vi sidder klar til at hjælpe.
            En fadølsbar kan være en fordelagtig ting at anskaffe til den næste fest og den egner sig både til sommerfesten, jubilæet, åbent hus, julefrokosten, festivaler og meget andet.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Fadølsbar til private
          </Heading2>
          <Paragraph>
            Lad en fadølsbar sætte prikken over i&apos;et til din næste fest. Du kan let leje den rette størrelse fadølsbar og du behøver ikke at bekymre dig over at skulle stille baren op og tage den ned samme dag. Prisen er nemlig for en lejeperiode, så du i ro og mag kan gøre klar til festen og samtidig også få lov til at sove lidt ekstra længe dagen efter.
            En fadølsbar kan med fordel lejes til bryllup, fødselsdag, havefest, jubilæum, konfirmation, julefrokost, påskefrokost og meget andet.
            Hvis du er i tvivl om den rette størrelse fadølsbar til din næste fest, er du naturligvis altid velkommen til at kontakt os. Vi er klar til at hjælpe dig med både fadølsbar og mængde af øl og andre drikkevarer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>
            Sådan lejer du en fadølsbar hos Skafte
          </Heading2>
          <Paragraph>
            Når du lejer en fadølsbar hos Skafte, kan du nyde godt af, at du har god tid. Prisen for leje er nemlig for en periode på op til fem dage (og ikke for en enkelt dag). Dette giver dig god tid til at kunne gøre klar til festen, uanset om det er erhverv eller privat. Der er desuden også tid til at kunne pakke ned efter festen, så der er mulighed for at få en god nats søvn.
          </Paragraph>
          <Paragraph>
            Når du vil booke en fadølsbar, vælger du blot den rette type og lægger i kurven. Inden du betaler, har du herefter mulighed for at vælge dato for levering og returnering. Du har mulighed for at hente fadølsbaren selv ved vores lager i Brøndby, eller få den leveret direkte til din eller din virksomheds adresse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
